export function userFavorites() {
    Alpine.data('userFavorites', () => ({
        selectedId: null,

        init() {
            this.$nextTick(() => this.select(this.$id('tab', 1)))
        },
        select(id) {
            this.selectedId = id
        },
        isSelected(id) {
            return this.selectedId === id
        },
        whichChild(el, parent) {
            return Array.from(parent.children).indexOf(el) + 1
        },

        tablist: {
            ['@keydown.right.prevent.stop']() {
                this.$focus.wrap().next()
            },
            ['@keydown.home.prevent.stop']() {
                this.$focus.first()
            },
            ['@keydown.page-up.prevent.stop']() {
                this.$focus.first()
            },
            ['@keydown.left.prevent.stop']() {
                this.$focus.wrap().prev()
            },
            ['@keydown.end.prevent.stop']() {
                this.$focus.last()
            },
            ['@keydown.page-down.prevent.stop']() {
                this.$focus.last()
            }
        },
    }))

    Alpine.data('favoriteList', () => ({
        items: 0,

        init() {
            this.items = this.$el.querySelectorAll('li').length
        },

        show() {
            return (this.items > 0) ? false : true;
        },

        remove_favorit: {
            ['@click.prevent.stop']() {
                let formData = new FormData()
                formData.append('action', 'update_favorite_status')
                formData.append('post_id', this.$el.dataset.postId)

                fetch(site_objects.ajax_url, {
                    method: "POST",
                    body: formData
                })
                    .then((res) => res.json())
                    .then((res) => {
                        if (res.success) {
                            let list = this.$el.parentElement.closest('ul');
                            this.$el.parentElement.remove()

                            this.items = list.querySelectorAll('li').length
                        }
                    })
            }
        }
    }))
}

